export default "__VITE_ASSET__ae0b4179__"